import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DexieDbService } from 'src/app/shared/services/dexie-db.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  environmentConfig = environment;
  serviceSubscription$ = new Subscription();
  isLoggedIn = '';
  isChecked: boolean = false;
  passLoginUrl;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dexieDbService: DexieDbService
  ) {
    const url=window.location.origin;
    const client_id=environment.passClientId;
    this.passLoginUrl = `${environment.passhost}auth/oidc/authorize?CountryCode=SG&LangCode=en&response_type=code&client_id=${environment.passClientId}&redirect_uri=${url}/shipment-list&scope=openid+email&state=SvElXlJG68y7Vv1k`;
  }

  ngOnInit() {
    sessionStorage.setItem('isLoggedIn', 'false');
    this.dexieDbService.clearTable();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.authService.data.subscribe(info => (this.isLoggedIn = info));
  }

  loginUser() {
    const username = this.loginForm.value.username;
    const password = this.loginForm.value.password;
    this.serviceSubscription$.add(
      this.authService.loginUser(username, password).subscribe((res: any) => {
        sessionStorage.setItem('cacheActive', 'false');
        this.authService.saveLoginInformation(res);
        this.authService.userLoggedInfo(true);
        this.router.navigateByUrl('/shipment-list').then();
      })
    );
  }

  ngOnDestroy(): void {
    this.serviceSubscription$.unsubscribe();
  }
}
